import { API } from "./api";

// DYMO LabelWriter 450 & 550 and Brother QL series (e.g. QL-820NWB) presets.
// Printing sets @page to the exact label size so the browser print dialog feeds correctly.
// Brother DK die-cut sizes are converted from mm to inches.
export const BADGE_LABELS = {
  dymo_30857: { name: 'DYMO 30857 Name Badge — 4" × 2¼" (LW 450/550)', w: 4, h: 2.25, layout: "row" },
  dymo_30364: { name: 'DYMO 30364 Badge Card — 2¼" × 4" (portrait)', w: 2.25, h: 4, layout: "col" },
  brother_dk1202: { name: 'Brother DK-1202 — 62mm × 100mm (QL-820NWB)', w: 2.44, h: 3.94, layout: "col" },
  brother_dk1201: { name: 'Brother DK-1201 — 29mm × 90mm address (QL-820NWB)', w: 3.54, h: 1.14, layout: "row" },
  brother_dk1247: { name: 'Brother DK-1247 — 103mm × 164mm large (QL-820NWB)', w: 4.06, h: 6.46, layout: "col" },
  standard: { name: 'Standard badge — 4" × 3"', w: 4, h: 3, layout: "row" },
};

export function printBadge(visitor, company, labelKey) {
  const origin = window.location.origin;
  const accent = company?.primary_color || "#1d54c4";
  const label = BADGE_LABELS[labelKey || company?.badge_label] || BADGE_LABELS.dymo_30857;
  const logo = company?.logo_path ? `${API}/files/${company.logo_path}` : `${origin}/rightpay-logo.png`;
  const photo = visitor.photo_path ? `${API}/files/${visitor.photo_path}` : null;
  const checkIn = new Date(visitor.check_in || Date.now()).toLocaleString([], {
    month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
  });
  const isCol = label.layout === "col";
  const photoSize = isCol ? 88 : 66;
  const photoEl = photo
    ? `<img class="photo" src="${photo}"/>`
    : `<div class="photo ph">${(visitor.name || "?")[0].toUpperCase()}</div>`;

  const meta = `
    ${visitor.organization ? `<div class="org">${visitor.organization}</div>` : ""}
    <div class="metablock">
      ${visitor.host ? `<div><b>Host:</b> ${visitor.host}</div>` : ""}
      ${visitor.purpose ? `<div><b>Reason:</b> ${visitor.purpose}</div>` : ""}
    </div>`;

  const bodyInner = isCol
    ? `<div class="body col">${photoEl}<div class="info center"><h1>${visitor.name}</h1>${meta}</div></div>`
    : `<div class="body row">${photoEl}<div class="info"><h1>${visitor.name}</h1>${meta}</div></div>`;

  const html = `<!doctype html><html><head><meta charset="utf-8"/>
  <title>Visitor Badge — ${visitor.name}</title>
  <style>
    @page { size: ${label.w}in ${label.h}in; margin: 0; }
    * { box-sizing: border-box; font-family: 'Segoe UI', Arial, sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    html, body { margin: 0; }
    body { display: flex; align-items: center; justify-content: center; background: #f1f5f9; }
    .badge { width: ${label.w}in; height: ${label.h}in; background: #fff; border: 2px solid ${accent}; overflow: hidden; display: flex; flex-direction: column; }
    .top { background: ${accent}; color: #fff; padding: 4px 10px; display: flex; align-items: center; justify-content: space-between; }
    .top .tag { font-size: 10px; letter-spacing: 2px; text-transform: uppercase; font-weight: 700; }
    .top .logo { background:#fff; border-radius:4px; padding:2px 5px; display:flex; }
    .top img { height: 20px; }
    .body { flex: 1; padding: 8px 12px; display: flex; gap: 10px; }
    .body.row { flex-direction: row; align-items: center; }
    .body.col { flex-direction: column; align-items: center; justify-content: center; text-align: center; }
    .photo { width: ${photoSize}px; height: ${photoSize}px; border-radius: 8px; object-fit: cover; border: 2px solid ${accent}; }
    .photo.ph { display:flex; align-items:center; justify-content:center; background:#e2e8f0; color:#64748b; font-size:28px; font-weight:700; }
    .info h1 { margin: 0; font-size: ${isCol ? 20 : 20}px; color: #0f172a; line-height: 1.1; }
    .info.center h1 { margin-top: 6px; }
    .org { color: #475569; font-size: 12px; margin-top: 2px; }
    .metablock { margin-top: 5px; font-size: 11px; color: #334155; line-height: 1.45; }
    .metablock b { color:#0f172a; }
    .foot { border-top: 1px dashed ${accent}; padding: 3px 10px; display: flex; justify-content: space-between; font-size: 9px; color: #64748b; }
    .foot .num { font-family: monospace; font-weight: 700; color: ${accent}; }
  </style></head>
  <body>
    <div class="badge">
      <div class="top"><span class="tag">Visitor</span><span class="logo"><img src="${logo}"/></span></div>
      ${bodyInner}
      <div class="foot"><span>${company?.name || "RightPay"} · ${checkIn}</span><span class="num">${visitor.badge_number}</span></div>
    </div>
    <script>window.onload = function(){ setTimeout(function(){ window.print(); }, 350); };</script>
  </body></html>`;

  const w = window.open("", "_blank", "width=520,height=460");
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
}
